import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
export const BlockScreenWrapperContext = React.createContext(false);
const AppBlockScreenProvider = ({ children }) => {
    const portrait = window.matchMedia('(orientation: portrait)');
    const { matches: isPortrait } = portrait;
    const [blockScreen, setBlockScreen] = useState(isPortrait);
    const onBlockScreenChange = useCallback((e) => {
        setBlockScreen(e.matches);
        if (window.innerHeight > window.innerWidth) {
            setBlockScreen(true);
        }
    }, [setBlockScreen]);
    useEffect(() => {
        portrait.addEventListener('change', onBlockScreenChange);
        return () => {
            portrait.removeEventListener('change', onBlockScreenChange);
        };
    }, [portrait, onBlockScreenChange]);
    return (_jsx(BlockScreenWrapperContext.Provider, Object.assign({ value: blockScreen }, { children: children })));
};
export default AppBlockScreenProvider;
